import logo from "../images/logo.jpg";

// import { Link } from "react-router-dom";

export default function EpisodeLink() {
  return (
    <div className="col1">
      <div className="card1">
        <div className="pic">
          <img src={logo} alt="" />
        </div>
        <p className="contain">
          {/* <Link to="../pages/episode"> */}
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt
          recusandae explicabo esse tenetur alias facilis minima corporis nam
          cumque non, inventore sapiente aliquam laboriosam suscipit ea
          excepturi amet incidunt temporibus?
          {/* </Link> */}
        </p>
      </div>
      <div className="card1">
        <div className="pic">
          <img src={logo} alt="" />
        </div>
        <p className="contain">
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptates
          et quisquam officiis, sequi maxime sapiente nam dolor quos numquam
          quia ea possimus aliquam illum aliquid quo laborum distinctio
          architecto inventore!
        </p>
      </div>
    </div>
  );
}
